import PropTypes from 'prop-types';
import MojitoCore from 'mojito/core';
import TaxAbsorptionDisclaimer from './tax-absorption-disclaimer.js';

const UIView = MojitoCore.Presentation.UIView;

/**
 * Component to display tax absorption disclaimer.
 *
 * @class TaxAbsorptionDisclaimer
 * @memberof Mojito.Modules.BetslipView
 */

/**
 * TaxAbsorptionDisclaimer props.
 *
 * @property {number} [tax = 0] - Tax value.
 * @property {string} [currencyCode] - Currency.
 * @property {string} [class] - Class name assigned to the root element.
 *
 * @memberof Mojito.Modules.BetslipView.TaxAbsorptionDisclaimer
 */

const propTypes = {
    tax: PropTypes.number,
    currencyCode: PropTypes.string,
    class: PropTypes.string,
};

const defaultProps = {
    tax: 0,
};

export default UIView('TaxAbsorptionDisclaimer', TaxAbsorptionDisclaimer, propTypes, defaultProps);
